import { Button } from 'src/v2/commonComponents/Button';
import styles from './SelectedPlanButton.module.scss';
import { CheckCircle } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';

export const SelectedPlanButton = () => {
  return (
    <Button fullWidth color="primary" className={styles.root}>
      <CheckCircle size={SVG_SIZE_M} weight="fill" />
      <span>Selected plan</span>
    </Button>
  );
};
